export default {

    isMobileAndroid() {
        return navigator.userAgent.match(/Android/i);
    },
    isMobileBlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    isMobileiOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    isMobileOpera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    isMobileWindows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    isMobile: function () {
        return (this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileiOS() || this.isMobileOpera() || this.isMobileWindows());
    },

    init() {
        // JavaScript to be fired on all pages

        jQuery('.share-content').jsSocials({
            showLabel: false,
            shareIn: 'popup',
            showCount: false,
            shares: [
                {
                    share: 'facebook',
                },
                {
                    share: 'linkedin',
                },
                {
                    share: 'twitter',
                },
            ],
        });

        jQuery('.backtotop').click(function () {
            jQuery('html, body').animate({scrollTop: 0}, 200);
        });

        jQuery('.owl-carousel.slider').owlCarousel({
            items: 1,
            loop: true,
            margin: 0,
            nav: false,
            dot: true,
            autoplay: true,
        });

        jQuery('#hamburger').click(function () {
            jQuery(this).toggleClass('open');
            jQuery('header nav').slideToggle();
        });

        $('#custom_login').submit(function (event) {
            if ($('#user_login').val() === '' || $('#user_pass').val() === '') {
                $('.form-custom-login-error').text('Inserisci username e password');
                event.preventDefault();
                return false;
            }
        });

        jQuery('#close-modal-search').click(function () {
            jQuery('.modale-search').fadeOut();
        });

        jQuery('.ricerca-avanzata-sidebar').click(function () {
            jQuery('.modale-search').fadeIn().css('display','flex');
        });

        var objimg = jQuery('.item-banner');
        var numitem=objimg.length;
        var numcount=0;
        var theInterval;
        if (jQuery('.slideshow-banner')[0]){
            startSlide();
        }

        function startSlide() {
            theInterval = setInterval(timerSlides, 2000);
        }

        function stopSlide() {
            clearInterval(theInterval);
        }

        jQuery('.next-banner').click(function(){
            numcount++;
            if (numcount > numitem) {
                numcount = 1
            }
            jQuery(objimg).removeClass( 'active' );
            jQuery(objimg[numcount-1]).addClass( 'active' );
            stopSlide() ;
        });

        jQuery('.prev-banner').click(function(){
            numcount--;
            if (numcount < 0) {
                numcount = numitem-1;
            }
            jQuery(objimg).removeClass( 'active' );
            jQuery(objimg[numcount]).addClass( 'active' );
            stopSlide() ;
        });


        function timerSlides() {
            numcount++;
            if (numcount > numitem) {
                numcount = 1
            }
                jQuery(objimg).removeClass( 'active' );
                jQuery(objimg[numcount-1]).addClass( 'active' );
            } 

            jQuery('.eye1').click(function(){
                jQuery(this).toggleClass('nothiddenpw');
                jQuery('.inputpw1').attr('type', function(index, attr){
                    return attr == 'password' ? 'text' : 'password';
                });
              });
              jQuery('.eye2').click(function(){
                jQuery(this).toggleClass('nothiddenpw');
                jQuery('.inputpw2').attr('type', function(index, attr){
                    return attr == 'password' ? 'text' : 'password';
                });
              });
              
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js